import { getStore } from "../store/store";
import type { CalendarSchedulingEntrySource } from "../store/store";

export function getCalendarSchedulingEntrySource(): CalendarSchedulingEntrySource | undefined {
    return getStore().entrySource;
}
